import { motion } from 'framer-motion';

/** Renders backend-managed content blocks with icons and bullet points */
export default function PageContentBlocks({ blocks, className = '' }) {
  if (!blocks?.length) return null;

  return (
    <div className={`space-y-8 ${className}`}>
      {blocks.map((block, i) => (
        <motion.div
          key={block.id}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.08 }}
          viewport={{ once: true }}
          className="card hover:border-brand-200 dark:hover:border-brand-800 transition-colors"
        >
          <div className="flex items-start gap-4">
            {block.icon && (
              <span className="text-4xl shrink-0">{block.icon}</span>
            )}
            <div className="flex-1">
              {block.title && (
                <h3 className="text-xl font-display font-bold text-gray-900 dark:text-white">
                  {block.title}
                </h3>
              )}
              {block.subtitle && (
                <p className="text-brand-600 dark:text-brand-400 font-medium mt-1 text-sm">
                  {block.subtitle}
                </p>
              )}
              {block.content && (
                <p className="text-gray-600 dark:text-gray-400 mt-3 leading-relaxed">
                  {block.content}
                </p>
              )}
              {block.bulletPoints?.length > 0 && (
                <ul className="mt-4 grid sm:grid-cols-2 gap-2">
                  {block.bulletPoints.map((point, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-gray-600 dark:text-gray-400">
                      <span className="text-brand-500 mt-0.5">✓</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
